<template>
    <CustomHeader :text="$t('gameLog.gameRegistration')" :is-popup-close-back-icon="true" @closePopup="navToBackPage" />
    <div class="container">
        <van-tabs v-model:active="active" sticky :ellipsis="false" @click-tab="onClickTab">
            <van-tab v-for="(item, index) in dataSet.tabList" :key="index" :title="`${item.timeName} ${$t(item.name)}`"
                :name="index">
                <div class="content">
                    <div class="top_card">
                        <div class="card_text">{{ $t('gameLog.latestData') }} {{ item.name }}</div>
                        <div class="card_text">{{ $t('common.bets') }} {{ dataSet.total }} {{ $t('common.times') }}:
                            <span>
                                {{ formatCurrency(dataSet.betTotal) }}
                            </span>
                        </div>
                        <div class="card_text">{{ $t('gameLog.winOrLoss') }}：
                            <span>
                                {{ formatCurrency(dataSet.winLossAmount) }}
                            </span>
                        </div>
                    </div>
                    <div v-if="dataSet.betList.length > 0" style="padding: 15px;">
                        <div v-for="(item, index) in dataSet.betList" :key="index">
                            <LogCard :bet-amount="item.betAmount" :returnAmount="item.winAmount" :profit="item.income"
                                :time="item.createTime" :sessionId="item.orderNo" :gameName="item.gameName" />
                        </div>
                        <van-row v-if="dataSet.total > dataSet.pageSize * dataSet.pageNum">
                            <van-col span="24" class="arrowDown"> <img src="@/assets/home/game_arrow_white.png" alt=""
                                    @click="getNextPageMsgList"></van-col>
                        </van-row>
                        <div v-else class="no_more">{{ $t('message.noMore') }}</div>
                    </div>
                    <div v-else>
                        <NoDataCustom />
                    </div>
                </div>
            </van-tab>
        </van-tabs>
    </div>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import LogCard from './components/logCard.vue';
import { formatCurrency } from '@/utils/commonFunction';
import CustomHeader from '../components/common/customHeader.vue';
import { GameLogData } from '@/view/gameLog/supportScript';
import { useRouter } from 'vue-router';
import NoDataCustom from '../components/common/noDataCustom.vue';

const router = useRouter()
const props = defineProps<{
    dataSet: GameLogData
}>()

const active = ref(props.dataSet.active);

const emits = defineEmits(['onClickTab', 'getNextPageMsgList'])

const onClickTab = (active: any) => {
    emits('onClickTab', active)
}
const getNextPageMsgList = () => {
    emits('getNextPageMsgList')
}
const navToBackPage = () => {
    router.go(-1)
}
</script>
<style scoped>
.container {
    padding-top: 50px;
    background: #003534;
    height: 100vh;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
}

.container>>>.van-tabs__wrap {
    height: 10vh;
}

.container>>>.van-tabs__nav {
    background: #03241F; 
    width: max-content;
    min-width: 100%;
    margin: 0 auto;
    padding: 15px 25px 0 20px; 
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
}

.container>>>.van-tab {
    font-size: 15px;
    margin: 0;
    height: 50px;
    padding: 0 15px; 
    color: rgba(255, 255, 255, .4);
    background: transparent;
    border-radius: 0;
    flex: none;
    font-weight: 500;
}

.container>>>.van-tab.van-tab--active {
    background: transparent;
    color: rgb(13, 176, 174);
    font-weight: bold;
    border: none;
}

.container>>>.van-tabs__line {
    display: block;
    background-color: rgb(13, 176, 174);
    height: 0.8px;
    bottom: 0px;
    border-radius: 0px;
}

.container>>>.van-tabs {
    flex: 1;
    display: flex;
    flex-direction: column;
    overflow: hidden;
}

.container>>>.van-tabs__content {
    flex: 1;
    overflow: hidden;
}

.container>>>.van-tab__panel {
    height: 100%;
}

.content {
    color: #fff;
    flex: 1;
    overflow-y: auto;
    height: calc(100vh - 210px);
    scrollbar-width: none;
    -ms-overflow-style: none;
}

.top_card {
    order: 2;
    background: rgb(2, 74, 73);
    padding: 15px 20px;
    width: 100%;
    box-sizing: border-box;
    border-top: 1px solid rgb(0, 97, 95);
}

.card_text {
    color: #fff;
    font-size: 14px;
    padding: 5px 0;
}

.card_text span {
    font-size: 15px;
    font-weight: 600;
}

.top_card .card_text:nth-child(2) span {
    color: rgb(83, 193, 84); 
}

.top_card .card_text:nth-child(3) span {
    color: rgb(230, 64, 33); 
}

.sub_text {
    color: rgba(255, 255, 255, 0.2);
    text-align: center;
    padding: 15px 70px;
    font-size: 12px;
}

.no_more {
    color: rgba(255, 255, 255, .2);
    display: flex;
    justify-content: center;
    padding: 10px;
    font-size: 14px;
}

.arrowDown {
    display: flex;
    justify-content: center;
}

.arrowDown img {
    width: 30px;
    transform: rotate(-90deg);
}

@media (max-width: 450px) {
    .card_text {
        font-size: 13px;
    }
    
    .card_text span {
        font-size: 14px;
    }
}
</style>